module.exports = __webpack_public_path__ + "static/media/coins_5.5adc4fe4.webp";